export default {

  props: ["contacts"],

  methods: {

    contactsForRole(role) {
      return this.contacts.filter(c => c.pivot.role.toLowerCase() === role.toLowerCase());
    }

  }

};